import { createApiClient, getHeader, getOrganizationIdParamString, handleError, handleResponse } from '@/helpers/api'

const apiCoverSheetClient = createApiClient(`${window.config.VUE_APP_UPLOAD_API_BASE_URL}`)

// EXPORTS
export const coverSheetService = {
  previewCoverSheet,
  getCoverSheet,
  getCoverSheets,
  mergeCoverSheet,
  uploadCoverSheet,
  updateCoverSheet,
  deleteCoverSheet,
  removeCoverSheetFromDocument
}

// API CALLS
async function previewCoverSheet(data) {
  return apiCoverSheetClient
    .post(`/CoverSheet/preview${getOrganizationIdParamString()}`,
      data,
      getHeader({ responseType: 'blob' }))
    .then(handleResponse)
    .catch(handleError)
}

async function getCoverSheet(id) {
  return apiCoverSheetClient
    .get(`/CoverSheet/${id}/image${getOrganizationIdParamString()}`,
      getHeader({ responseType: 'blob' }))
    .then(handleResponse)
    .catch(handleError)
}

async function getCoverSheets() {
  return apiCoverSheetClient
    .get(`/CoverSheet/list${getOrganizationIdParamString()}`)
    .then(handleResponse)
    .catch(handleError)
}

async function mergeCoverSheet(data) {
  return apiCoverSheetClient
    .post(`/CoverSheet/merge${getOrganizationIdParamString()}`, data)
    .then(handleResponse)
    .catch(handleError)
}

async function uploadCoverSheet(data) {
  return apiCoverSheetClient
    .post('/CoverSheet/upload',
      data,
      getHeader({ 'Content-Type': 'multipart/form-data' }))
    .then(handleResponse)
    .catch(handleError)
}

async function updateCoverSheet(data, templateId) {
  return apiCoverSheetClient
    .put(`/CoverSheet/${templateId}`,
      data,
      getHeader({ 'Content-Type': 'multipart/form-data' }))
    .then(handleResponse)
    .catch(handleError)
}

async function deleteCoverSheet(id) {
  return apiCoverSheetClient
    .delete(`/CoverSheet/${id}${getOrganizationIdParamString()}`)
    .then(handleResponse)
    .catch(handleError)
}

async function removeCoverSheetFromDocument(documentId) {
  return apiCoverSheetClient
    .put(`/CoverSheet/clean/${documentId}${getOrganizationIdParamString()}`, {})
    .then(handleResponse)
    .catch(handleError)
}
